module.exports = __webpack_public_path__ + "static/media/01_avatar_female.4da01583.png";